import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import { runtimeConfig } from '@app/config/runtime'

let firebaseApp: firebase.app.App | null = null

export const hasFirebaseConfig = () => runtimeConfig.firebase.isConfigured

export const getFirebaseApp = () => {
  if (!hasFirebaseConfig()) {
    return null
  }

  if (firebaseApp) {
    return firebaseApp
  }

  firebaseApp = firebase.apps[0] ?? firebase.initializeApp(runtimeConfig.firebase.config)

  return firebaseApp
}

export const getFirebaseAuth = () => getFirebaseApp()?.auth() ?? null

export const getFirebaseFirestore = () => getFirebaseApp()?.firestore() ?? null

export const getFirebaseStorage = () => getFirebaseApp()?.storage() ?? null

export const getCurrentFirebaseUser = () => getFirebaseAuth()?.currentUser ?? null

export function requireFirebaseApiKey() {
  const apiKey = runtimeConfig.firebase.config.apiKey.trim()

  if (!apiKey) {
    throw new Error('Firebase API key is not configured for this environment.')
  }

  return apiKey
}

export function requireFirebaseAuth() {
  const auth = getFirebaseAuth()

  if (!auth) {
    throw new Error('Firebase Auth is not configured for this environment.')
  }

  return auth
}

export function requireFirebaseFirestore() {
  const firestore = getFirebaseFirestore()

  if (!firestore) {
    throw new Error('Cloud Firestore is not configured for this environment.')
  }

  return firestore
}

export function requireFirebaseStorage() {
  const storage = getFirebaseStorage()

  if (!storage) {
    throw new Error('Cloud Storage is not configured for this environment.')
  }

  return storage
}

